import { Injectable } from "@angular/core";
import { BaseDataService, ConfirmationDialogButtons, ErrorHandlerService, ModalService, ModelDataService, NotificationService, QueryParameter } from "yt-ng-framework";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { EPrijemnicaUpdateComponent } from "./eprijemnica-update.component";
import { EPrijemnica } from "./eprijemnica";
import { EPrijemnicaView } from "./eprijemnica-view";
import { HttpErrorResponse } from "@angular/common/http";
import { EPrijemnicaTabsComponent } from "./eprijemnica-tabs.component";
import { EPrijemnicaTabUpdateComponent } from "./eprijemnica-tab-update.component";

@Injectable({
    providedIn: 'root'
  })
  export class EPrijemnicaService {
        constructor(
            protected baseDataService: BaseDataService,
            protected translateService: TranslateService,
            protected modalService: ModalService,
            protected errorService: ErrorHandlerService,
            protected modelDataService: ModelDataService,
            protected router: Router,
            protected toastrService: NotificationService
             
        ) {  }

  public baseUpdateComponent: EPrijemnicaUpdateComponent
  public baseTabsComponent: EPrijemnicaTabsComponent
  public baseTabUpdate: EPrijemnicaTabUpdateComponent

  checkUnsavedChanges (
    modalFunction: () => void, 

  ) {
      if (!this.baseUpdateComponent.canDeactivate()) {
          this.modalService.ShowConfirmationDialog(
              "Obaveštenje",
              'Postoje promene u tekućim podacima. Da li želite da ih sačuvate pre nastavka?',
              "question",
              ConfirmationDialogButtons.ConfirmCancel 
          ).result.then((result) => {
              if (result === ConfirmationDialogButtons.ConfirmCancel || result === true) {
                  this.baseUpdateComponent.SaveItem(); 
                  modalFunction(); 
              }
             
          }).catch(() => {});
      } else {
          modalFunction(); 
      }
  }

  PrihvatiPrijemnicu(){
      let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
    this.PrihvatiPrijemnicuService(id);
  }
  

  getProvajderGenericName(id: number) {
      var parameters = [];
      var provajderId = new QueryParameter();
      provajderId.Name = "id";
      provajderId.Value = id;
      parameters.push(provajderId);
      return this.baseDataService.Get(
        "Provajder",
        "getGenericName",
        parameters,
        null
      );
    }

  PrihvatiPrijemnicuService(id){
      this.baseDataService
          .GetByID("EPrijemnica",id,EPrijemnica)
          .subscribe((item:EPrijemnica) => {
            this.getProvajderGenericName(item.ProvajderID).subscribe(
              (genericName: any) => {
                if (
                  genericName == "Sef_t" ||
                  genericName == "Sef_p"
                ){
                 this.translateService.get(["EPRIJEMNICA.PRIHVATIPRIJEMNICU.SINGULAR","EPRIJEMNICA.PRIHVATIPRIJEMNICU.QUESTION"])
                .subscribe(translate => {
                this.modalService.ShowConfirmationDialog(translate["EPRIJEMNICA.PRIHVATIPRIJEMNICU.SINGULAR"],
                  translate["EPRIJEMNICA.PRIHVATIPRIJEMNICU.QUESTION"],
                  "info",ConfirmationDialogButtons.YesNo)
                  .result.then(
                    (result) =>{
                      if (result === false)
                        return;
    
                      let idParameter = new QueryParameter("ePrijemnicaId",id);
                      this.baseDataService.Get("EPrijemnica","PrihvatiPrijemnicu",[idParameter],null)
                      .subscribe(
                        (poruka: any) => {
                            if (poruka)
                                this.translateService
                                .get(['EPRIJEMNICA.PRIHVATIPRIJEMNICU.SUCESS'])
                                .subscribe(translate => {
                                  setTimeout(()=>{
                                    this.toastrService.success(translate['EPRIJEMNICA.PRIHVATIPRIJEMNICU.SUCESS'], poruka);
                                  }, 0)
                                  this.OsveziStatus(id);
                                });
                              }
                              , error => {
                                let _message;
                                let translatedMessage: string = "";
                                if (error instanceof HttpErrorResponse) {
                                  _message = this.errorService.getServerMessage(error);
                                  if (_message instanceof ArrayBuffer) {
                                    _message = new TextDecoder('utf-8').decode(new Uint8Array(_message));
                                    let message: string = _message;
                                    if (message.includes('EPRIJEMNICA')){
                                      let messageArray: string[] = message.split(';');
                                      messageArray.forEach((element, index) => {
                                        messageArray[index] = "FW.ERRORS." + element;
                                      });
                                      this.translateService.get(messageArray)
                                      .subscribe(translate => {
                                        translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                                      });
                                    }
                                    else 
                                      translatedMessage = message;
                                  }
                                  else{
                                    translatedMessage = this.errorService.getClientMessage(error.error);
                                  }
                                }
                                this.modalService.ShowConfirmationDialog(
                                  "Problemi kod prihvatanja prijemnice", 
                                  translatedMessage, 
                                  "warning", 
                                  ConfirmationDialogButtons.Ok);
                              }
                      )
                    }
                  )  
                })
                }
              }
            )
          })
  }
  OdbijPrijemnicu(){
    let id: number = this.baseUpdateComponent.baseFormGroup.get("ID").value;
    this.OdbijPrijemnicuService(id);
  }
  
   OdbijPrijemnicuService(id:number){
    this.baseDataService
        .GetByID("EPrijemnica",id,EPrijemnica)
        .subscribe((item: EPrijemnica) => {
          this.getProvajderGenericName(item.ProvajderID).subscribe(
            (genericName: any) => {
              if (
                genericName == "Sef_t" ||
                genericName == "Sef_p"
              ){
                this.translateService.get(["EPRIJEMNICA.ODBIJPRIJEMNICU.SINGULAR","EPRIJEMNICA.ODBIJPRIJEMNICU.QUESTION"])
                .subscribe(translate => {
                this.modalService.ShowConfirmationDialog(translate["EPRIJEMNICA.ODBIJPRIJEMNICU.SINGULAR"],
                  translate["EPRIJEMNICA.ODBIJPRIJEMNICU.QUESTION"],
                  "info",ConfirmationDialogButtons.YesNo)
                  .result.then(
                    (result) =>{
                      if (result === false)
                        return;
    
                      let idParameter = new QueryParameter("ePrijemnicaId",id);
                      this.baseDataService.Get("EPrijemnica","OdbijPrijemnicu",[idParameter],null)
                      .subscribe(
                        (poruka: any) => {
                            if (poruka)
                                this.translateService
                                .get(['EPRIJEMNICA.ODBIJPRIJEMNICU.SUCESS'])
                                .subscribe(translate => {
                                  setTimeout(()=>{
                                    this.toastrService.success(translate['EPRIJEMNICA.ODBIJPRIJEMNICU.SUCESS'], poruka);
                                  }, 0)
                                  this.OsveziStatus(id);
                                });
                              }
                              , error => {
                                let _message;
                                let translatedMessage: string = "";
                                if (error instanceof HttpErrorResponse) {
                                  _message = this.errorService.getServerMessage(error);
                                  if (_message instanceof ArrayBuffer) {
                                    _message = new TextDecoder('utf-8').decode(new Uint8Array(_message));
                                    let message: string = _message;
                                    if (message.includes('EPRIJEMNICA')){
                                      let messageArray: string[] = message.split(';');
                                      messageArray.forEach((element, index) => {
                                        messageArray[index] = "FW.ERRORS." + element;
                                      });
                                      this.translateService.get(messageArray)
                                      .subscribe(translate => {
                                        translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                                      });
                                    }
                                    else 
                                      translatedMessage = message;
                                  }
                                  else{
                                    translatedMessage = this.errorService.getClientMessage(error.error);
                                  }
                                }
                                this.modalService.ShowConfirmationDialog(
                                  "Problemi kod odbijanja prijemnice", 
                                  translatedMessage, 
                                  "warning", 
                                  ConfirmationDialogButtons.Ok);
                              }
                      )
                    }
                  )
    
                })
              }
            }
          )})
  }

  prevod: string;
  bojaStatusa: string;
  nazivStatusa: string;
  OsveziStatus(id: number){

      this.baseTabUpdate.defaultUpdateButtons.ButtonsConfig.ContextMenuButtonConfig.Enable = false;
      let idParameter = new QueryParameter("id",id);
      let vrsta = this.baseUpdateComponent.modelData["MainList"]["UserRightsModelName"];
      let vrstaParameter = new QueryParameter("vrsta",vrsta);
      this.baseDataService 
          .Get("EPrijemnica","OsveziStatus",[idParameter,vrstaParameter], EPrijemnicaView)
          .subscribe(async (data: EPrijemnicaView[]) =>{
            
            if (data != null && data.length > 0)
            {
              this.bojaStatusa = data[0].StatusColor;
              this.nazivStatusa = data[0].StatusTooltip;
            } 
            else 
            {
              this.bojaStatusa = "transparent";
              this.nazivStatusa = "";
            }  

             const refreshedItem: any = await this.baseDataService 
              .Get("EPrijemnica","GetViewItemByID",[idParameter], EPrijemnicaView)
              .toPromise();
             this.baseTabsComponent.tabsContainerService.EmitItem(refreshedItem);
             this.baseTabsComponent.baseTabsUpdate['bojaStatusa'] = this.bojaStatusa;   
             this.baseTabsComponent.baseTabsUpdate.baseUpdateComponent.Item.StatusGenericName = data[0].StatusGenericName;  
             this.baseTabUpdate.defaultUpdateButtons.ButtonsConfig.ContextMenuButtonConfig.Enable = true;
             this.baseTabsComponent.baseTabsUpdate['nazivStatusa'] = this.nazivStatusa;

          }
          ,error => {
              throw error;
          });
   
  }



  }
